import { render } from "./LocaleSwitcher.vue?vue&type=template&id=5964fa71&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=5964fa71&scoped=true&lang=sass"

import exportComponent from "/builds/web-nfb/collection/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5964fa71"]])

export default __exports__